import { Container, Nav } from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import Image from 'react-bootstrap/Image';
import { NavLink, useLocation } from 'react-router-dom';
import { config } from '../../config';
import { DEFAULT_LOCATION, resolveLocationFromUrl } from '../../location';

const Navigation = () => {
  const location = useLocation();
  const { Link, Item } = Nav;
  const { branding } = config;
  const logosByLocation = branding?.logosByLocation as Record<string, string[]> | undefined;
  const featuresByLocation = config.featuresByLocation as
    | Record<string, { enableMMP?: boolean; enableDarkMode?: boolean }>
    | undefined;
  const logoCentredByLocation = branding?.logoCentred as Record<string, boolean | null> | undefined;
  const locationByHost = config.locationByHost as Record<string, string> | undefined;
  const { locationId, isPathScoped, isKnownLocation } = resolveLocationFromUrl({
    pathname: location.pathname,
    hostname: window.location.hostname,
    featuresByLocation,
    locationByHost,
    defaultLocation: DEFAULT_LOCATION,
  });
  const defaultFeatures = featuresByLocation?.['penicuik'] || {
    enableMMP: false,
    enableDarkMode: false,
  };
  const locationFeatures =
    featuresByLocation?.[locationId] || featuresByLocation?.[`/${locationId}`] || defaultFeatures;
  const enableMMP = locationFeatures.enableMMP ?? false;
  const locationPrefix = isKnownLocation && isPathScoped ? `/${locationId}` : '';
  const signpostPath = locationPrefix || '/';
  const mmpPath = `${locationPrefix}/mmp`;
  const locationLogos = logosByLocation?.[locationId] || logosByLocation?.[`/${locationId}`];
  const logoCentred =
    logoCentredByLocation?.[locationId] ?? logoCentredByLocation?.[`/${locationId}`] ?? null;
  const logos =
    locationLogos && locationLogos.length > 0
      ? locationLogos
      : branding?.logos?.length
        ? branding.logos
        : ['practice_logo.png'];

  return (
    <>
      <div className={`logo-bar${logoCentred ? ' logo-bar-centred' : ''}`}>
        <NavLink to={signpostPath}>
          <div className="brand-logos">
            {logos.map((logo: string, index: number) => (
              <Image
                key={`${logo}-${index}`}
                src={logo.startsWith('/') ? logo : `/${logo}`}
                rounded
                className="brand-logo"
                alt={`Practice logo ${index + 1}`}
              />
            ))}
          </div>
        </NavLink>
      </div>
      <Navbar expand="lg">
        <Container fluid>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav
              className="mx-auto my-2 my-lg-0"
              style={{ maxHeight: '100px' }}
              navbarScroll
              variant="tabs"
              defaultActiveKey="/"
            >
              {enableMMP && (
                <>
                  <Item>
                    <Link as={NavLink} to={signpostPath}>
                      Signpost
                    </Link>
                  </Item>
                  <Item>
                    <Link as={NavLink} to={mmpPath}>
                      MMP
                    </Link>
                  </Item>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export { Navigation };
